import { useEffect } from "react";
import ReactGA from "react-ga4";
import { BrowserRouter, Route, Routes } from "react-router-dom";

//importing components
import AuthModalRoute from "./Auth/AuthModalRoute";
import CustomerRoute from "./Auth/CustomerRoute";
import AuthModal from "./Components/AuthModal/AuthModal";
import Categories from "./Components/Categories/Categories";
import CartCheckout from "./Views/CartCheckout/CartCheckout";
import CustomerAccount from "./Views/CustomerAccount/CustomerAccount";
import CustomerCoupons from "./Views/CustomerCoupons/CustomerCoupons";
import CustomerLists from "./Views/CustomerLists/CustomerLists";
import CustomerOrders from "./Views/CustomerOrders/CustomerOrders";
import DataProtection from "./Views/DataProtection/DataProtection";
// import DesiFamily from "./Views/DesiFamily/DesiFamily";
import DesiHands from "./Views/DesiHands/DesiHands";
import DiscountAndOffer from "./Views/DiscountAndOffer/DiscountAndOffer";
import FAQ from "./Views/FAQ/FAQ";
import ForgotPassword from "./Views/ForgotPassword/ForgotPassword";
import Imprint from "./Views/Imprint/Imprint";
import Landing from "./Views/Landing/Landing";
import LandingV2 from "./Views/LandingV2/LandingV2";
import Menu from "./Views/Menu/Menu";
import MyDesiFamily from "./Views/MyDesiFamily/MyDesiFamily";
import OrderInvoice from "./Views/OrderInvoice/OrderInvoice";
import OrderSuccess from "./Views/OrderSuccess/OrderSuccess";
import OurStory from "./Views/OurStory/OurStory";
import ProductDescription from "./Views/ProductDescription/ProductDescription";
// import Products from "./Views/Products/Products";
import ProductsByCategory from "./Views/ProductsByCategory/ProductsByCategory";
import PublicOrderTrack from "./Views/PublicOrderTrack/PublicOrderTrack";
import QualityAuthenticity from "./Views/QualityAuthenticity/QualityAuthenticity";
import ReturnRefunds from "./Views/ReturnRefunds/ReturnRefunds";
import Search from "./Views/Search/Search";
import TermsAndCondition from "./Views/TermsAndCondition/TermsAndCondition";
import TrackOrder from "./Views/TrackOrder/TrackOrder";
import CustomerService from "./Views/CustomerService/CustomerService";
import CustomerDataPayment from "./Views/CustomerDataPayment/CustomerDataPayment";
import InviteFriend from "./Views/InviteFriend/InviteFriend";
import NotFound from "./Views/NotFound/NotFound";
import ProductsByBrand from "./Views/ProductsByBrand/ProductsByBrand";
import ThinkGreen from "./Views/ThinkGreen/ThinkGreen";
import ProductRecalls from "./Views/ProductRecalls/ProductRecalls";
import ContactUs from "./Views/ContactUs/ContactUs";

const TRACKING_ID = "G-YP4V199P8C"; // PROJECT_TRACKING_ID
ReactGA.initialize(TRACKING_ID);

function App() {
    useEffect(() => {
        // ReactGA.pageview(window.location.pathname + window.location.search);
        ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search, title: window.location.title });
    }, []);

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<LandingV2 />} />
                {/* login / sign up live in a global modal - these two only open it */}
                <Route path="/register" element={<AuthModalRoute mode="register" />} />
                <Route path="/sign-in" element={<AuthModalRoute mode="signin" />} />
                <Route path="/our-story" element={<OurStory />} />
                <Route path="/coming-soon" element={<Landing />} />
                <Route path="/categories" element={<Categories />} />
                <Route path="/category/:slug" element={<ProductsByCategory />} />
                <Route path="/brand/:slug" element={<ProductsByBrand />} />
                {/*<Route path="/products" element={<Products />} />*/}
                <Route path="/products/:slug" element={<ProductDescription />} />
                <Route path="/cart-checkout" element={<CartCheckout />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/order/success/:id" element={<OrderSuccess />} />
                <Route path="/search" element={<Search />} />
                <Route path="/order/invoice" element={<OrderInvoice />} />
                <Route path="/track-order" element={<PublicOrderTrack />} />
                <Route path="/track-order/:id" element={<TrackOrder />} />
                <Route path="/discount-and-offer" element={<DiscountAndOffer />} />
                <Route path="/menu" element={<Menu />} />
                <Route path="/faq" element={<FAQ />} />
                {/* <Route path="/desi-family" element={<DesiFamily />} /> */}
                <Route path="/desi-hands" element={<DesiHands />} />
                <Route path="/imprint" element={<Imprint />} />
                <Route path="/terms-and-condition" element={<TermsAndCondition />} />
                <Route path="/data-protection" element={<DataProtection />} />
                <Route path="/quality-authenticity" element={<QualityAuthenticity />} />
                <Route path="/think-green" element={<ThinkGreen />} />
                <Route path="/product-recalls" element={<ProductRecalls />} />
                <Route path="/contact-us" element={<ContactUs />} />

                {/* customer specific routes */}
                <Route element={<CustomerRoute />}>
                    <Route path="/customer/account" element={<CustomerAccount />} />
                    <Route path="/customer/orders" element={<CustomerOrders />} />
                    <Route path="/customer/coupons" element={<CustomerCoupons />} />
                    <Route path="/customer/return-refunds" element={<ReturnRefunds />} />
                    <Route path="/customer/lists" element={<CustomerLists />} />
                    <Route path="/customer/my-desi-family" element={<MyDesiFamily />} />
                    <Route path="/customer/customer-service" element={<CustomerService />} />
                    <Route path="/customer/data-payment" element={<CustomerDataPayment />} />
                    <Route path="/customer/invite-friend" element={<InviteFriend />} />
                </Route>

                <Route path="*" element={<NotFound />} />
            </Routes>

            {/* rendered outside <Routes> so it survives navigation */}
            <AuthModal />
        </BrowserRouter>
    );
}

export default App;
